module.exports = __webpack_public_path__ + "img/firma_template5.19261eb.svg";